import { useState, useEffect } from "react";
import { IconSun, IconMoon } from "@tabler/icons-react";

// The light/dark choice: starts from the saved value (or the current <html> class), applies it to <html> and remembers it.
// Returns [isDark, toggle]. Shared by the icon button below and by the drawer menu's "Dark mode" row.
export function useColorScheme() {
    const [isDark, setIsDark] = useState(() => {
        return localStorage.getItem("theme") === "dark" ||
            (!localStorage.getItem("theme") && document.documentElement.classList.contains("dark"));
    });

    useEffect(() => {
        if (isDark) {
            document.documentElement.classList.add("dark");
            document.documentElement.setAttribute("data-mantine-color-scheme", "dark");
            localStorage.setItem("theme", "dark");
        } else {
            document.documentElement.classList.remove("dark");
            document.documentElement.setAttribute("data-mantine-color-scheme", "light");
            localStorage.setItem("theme", "light");
        }
    }, [isDark]);

    return [isDark, () => setIsDark((prev) => !prev)];
}

export default function ColorSchemeToggle({ size = "md" }) {
    const [isDark, toggle] = useColorScheme();

    const btnSize = size === "sm" ? "w-7 h-7" : "w-8 h-8";
    const iconSize = size === "sm" ? 16 : 18;

    return (
        <button
            onClick={toggle}
            aria-label="Toggle color scheme"
            title={isDark ? "লাইট মোড" : "ডার্ক মোড"}
            className={`${btnSize} inline-flex items-center justify-center rounded-md transition-colors
                text-zinc-600 dark:text-yellow-400
                hover:bg-zinc-100 dark:hover:bg-zinc-700 focus:outline-none`}
        >
            {isDark ? <IconSun size={iconSize} /> : <IconMoon size={iconSize} />}
        </button>
    );
}
